package com.partejar.app.core.ui.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Shapes
import androidx.compose.ui.unit.dp

object PartejarShapes {
    val radius6 = RoundedCornerShape(6.dp)
    val radius10 = RoundedCornerShape(10.dp)
    val radius14 = RoundedCornerShape(14.dp)
    val radius20 = RoundedCornerShape(20.dp)
    val radius28 = RoundedCornerShape(28.dp)
    val pill = RoundedCornerShape(percent = 50)
}

internal val PartejarMaterialShapes = Shapes(
    extraSmall = PartejarShapes.radius6,
    small = PartejarShapes.radius10,
    medium = PartejarShapes.radius14,
    large = PartejarShapes.radius20,
    extraLarge = PartejarShapes.radius28
)
